export function joinTitles(titles: readonly string[], conjunction: 'and' | 'or'): string {
  const [first = '', ...rest] = titles;
  if (rest.length === 0) return first;
  if (rest.length === 1) return `${first} ${conjunction} ${rest[0]}`;
  return `${first} ${conjunction} ${rest.length} more`;
}
